import { render, staticRenderFns } from "./HomePageUpdateWrapper.vue?vue&type=template&id=1c5caa08&scoped=true"
import script from "./HomePageUpdateWrapper.vue?vue&type=script&lang=js"
export * from "./HomePageUpdateWrapper.vue?vue&type=script&lang=js"
import style0 from "./HomePageUpdateWrapper.vue?vue&type=style&index=0&id=1c5caa08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5caa08",
  null
  
)

export default component.exports